import React, { useState } from "react";
import "@patternfly/react-core/dist/styles/base.css";
import { AppLayout } from "@app/AppLayout/AppLayout";
import { AppRoutes } from "@app/routes";
import "@app/app.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "@app/Login/Login";
import useToken from "@app/Login/useToken";
import { ForgotPasswordPage } from "@app/Login/ForgotPasswordPage";
import { ResetPasswordPage } from "@app/Login/ResetPasswordPage";

const App: React.FunctionComponent = () => {
  const {token, setToken} = useToken();

  return (
    <Router>
      <Routes>
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/*" element={
          !token ? (
            <Login setToken={setToken} />
          ) : (
            <AppLayout>
              <AppRoutes />
            </AppLayout>
          )
        } />
      </Routes>
    </Router>
  );
};

export { App };
